/** Contains the top bar used within the chat pages */

import * as preact from "preact";

import * as browserTTS from "browserTTS";
import * as languageMap from "shared/languageMap";
import { cn } from "shared/utils";
import * as browserTTSVoices from "../browserTTSVoices";

interface Props {
  title: string;
  ttsVoices: { voiceURI: string; displayName: string }[];
  language: string;
  close: () => void;
}

interface State {
  selected: boolean;
}

export class TTSVoicePickerView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const selectedVoiceURI = browserTTSVoices.getVoice(this.props.language);

    this.state = {
      selected: this.props.ttsVoices.find(
        (voice) => voice.voiceURI === selectedVoiceURI
      )
        ? true
        : false,
    };
  }

  render() {
    const currentVoiceURI = browserTTSVoices.getVoice(this.props.language);
    const currentRate = browserTTSVoices.getRate(this.props.language);

    return (
      <div class="ttsVoicePicker">
        <h2>{this.props.title}</h2>
        <div>
          These are all the {languageMap.map[this.props.language].english}{" "}
          voices available within this browser.
        </div>
        <ul class="voiceList">
          {this.props.ttsVoices.map((voice) => {
            return (
              <li
                class={cn({
                  voiceOption: true,
                  selected: voice.voiceURI === currentVoiceURI,
                })}
                onClick={async () => {
                  browserTTSVoices.setVoice(
                    this.props.language,
                    voice.voiceURI
                  );
                  browserTTS.playVoiceDemo(this.props.language);
                  await this.setState({ selected: true });
                  this.forceUpdate();
                }}
              >
                {voice.displayName}
              </li>
            );
          })}
        </ul>
        <p>
          <span class="rateLabel">Rate:</span>{" "}
          {[0.6, 0.8, 1, 1.2, 1.5, 2].map((rate) => (
            <span
              class={cn({
                rateOption: true,
                selected: rate.toString() === currentRate,
              })}
              data-value={rate}
              onClick={async () => {
                if (!this.state.selected) {
                  alert("Select a voice first");
                  return;
                }
                browserTTSVoices.setRate(this.props.language, rate.toString());
                browserTTS.playVoiceDemo(this.props.language);
                await this.setState({ selected: true });
                this.forceUpdate();
              }}
            >
              {rate}X
            </span>
          ))}
        </p>
        <p>
          <button
            class="prominent continueButton"
            onClick={() => {
              this.props.close();
            }}
            disabled={!this.state.selected}
          >
            Continue
          </button>
        </p>
      </div>
    );
  }
}

export default TTSVoicePickerView;
